<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="User Info"
            bc1="App"
            bc2="User Info"
            bc3="List"
            path="User Info"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="row">
            <div class="col-md-4 m-2">
              <date-picker
                 class="w-100"
                  v-model="toDate"
                 :disabledDate="disableFutureDates"
                  valueType="format"
                 v-validate="'required'"
                  :lang="lang"
                  name="toDate"
                  placeholder="Closing Balance Till Date"
              ></date-picker>
              <p class="text-danger" v-if="error">{{ error }}</p>
            </div>
            <div class="col-md-4 mt-2 mb-2 mr-2">
              <button type="button" class="btn btn-primary btn-sm" @click="onSubmitFilters" >Search</button>
              <button type="button" class="ml-1 btn btn-secondary btn-sm "  @click="clear">Clear</button>
            </div>
          </div>
          <div class="card" v-if="showFilterComp">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>S.No</th>
                  <th>Account_title</th>
                  <th>Account Number</th>
                  <th>Currency</th>
                  <th>balance</th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in list">

                  <td>{{index+1}}</td>
                  <td><span class="badge-light-primary badge">{{item.account_title}}</span></td>
                  <td>{{item.account_number}}</td>
                  <td><span class="badge-light-success badge">{{currencyCode}}</span></td>


                  <td>{{parseFloat(item.balance / 100).toFixed(feesDecimalPlaces)}}</td>



                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-body" v-show="loading">
            <div class="col-12 d-flex mt-2  justify-content-center" >
              <div class="spinner-border text-primary"></div>
            </div>
          </div>
          <template v-if="!showFilterComp">
            <CommonTable
                :url="url"
                :tableHeaderValues="tableHeaderValues"
                :actions="actions"
                :deleteActions="deleteActions"
                :mutedData="mutedData"
                :storageKey="storageKey"
                :externalTotalRecord="externalTotalRecord"
                :filteredData="filteredData"
                :show-per-page="true"
            />
          </template>

        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

import DatePicker from "vue2-datepicker";

export default {
  components:{
    DatePicker
  },
  created() {
    this.url = "v1/dashboard-overview";
  },
  mounted() {
    localStorage.setItem("url", "v1/dashboard-overview");
    this.checkDataInStore('v1/dashboard-overview')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
    this.currencyCode = this.$route.params.currencyCode
  },
  data() {
    return {
      error: "",
      loading:false,
      currencyCode:'',
      list:[],
      showFilterComp:false,
      url: "v1/dashboard-overview",
      toDate: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      storageKey: "user-stat",
      filteredData:{currencyId: parseInt(this.$route.params.currencyId),isMerchant: parseInt(this.$route.params.merchantStatus)},
      tableHeaderValues: [
        {
          title: "Account Title",
          valueKey: "account_title",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return `<a href="javascript:void()" class="badge badge-glow badge-dark">${value}</a>`;
            }
          }
        },
        {
          title: "User Name",
          valueKey: "user",
          html: true,
          alter: function(value) {
            var html = "-";
            if(value)
            html = `<span class="text-primary" >${value.first_name+' '+value.last_name}</span>`;
            return html;
          }
        },
        {
          title: "User Email",
          valueKey: "user",
          html: true,
          alter: function(value) {
            var html = "-";
            if(value)
            html = `<span class="badge badge-light-primary" >${value.email}</span>`;
            return html;
          }
        },
        {
          title: 'Currency',
          valueKey: 'currency.code',
          html: true,
          alter: (value,row) => {
            var html='-'
            if(value)
              html = ` <div  class="badge badge-light-success">${value}</div>`


            return  html
          }
        },
        {
          title: 'Available Balance',
          valueKey: 'available_balance',
          html: true,
          alter: (value,row) => {
            var html='-'

            html = ` <div  class="  text-dark">${this.modifyAmount(parseFloat(value / 100).toFixed(this.feesDecimalPlaces))}</div>`


            return  html
          }
        },
        {
          title: 'Balance',
          valueKey: 'balance',
          html: true,
          alter: (value,row) => {
            var html='-'

            html = ` <div  class="  text-dark">${this.modifyAmount(parseFloat(value / 100).toFixed(this.feesDecimalPlaces))}</div>`


            return  html
          }
        },
        {
          title: 'Balance On Hold',
          valueKey: 'balance_on_hold',
          html: true,
          alter: (value,row) => {
            var html='-'

            html = ` <div  class="  text-dark">${this.modifyAmount(parseFloat(value / 100).toFixed(this.feesDecimalPlaces))}</div>`


            return  html
          }
        },


      ],
      actions: [
      ],
      deleteActions: [

      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    getDashboardOverviewStatsWithFilter() {
      let filter = {
        ...this.filteredData,

      }
      if(this.toDate){
        filter.toDate = this.toDate
      }
      this.loading = true
      this.makeRequest("post", "v1/dashboard-overview", filter, {}, false,false,[205]).then(
          (callResponse) => {
            this.loading = false
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.list = responseData
                return

              }
            }
          }


      )
      this.list=[]
    },
    onSubmitFilters() {
      if(!this.toDate){
        this.error = "Date Field is required";
        return
      }
      this.error = "";
      this.showFilterComp = true
      this.getDashboardOverviewStatsWithFilter()
    },
    clear(){
      if(!this.toDate){
        this.error = "";
        return
      }
      this.toDate = null
      this.list=[]
      this.showFilterComp = false
    },
  }
};
</script>

